module.exports = __webpack_public_path__ + "img/mw-transfer.ddfa6c85.png";